// @ts-check
import { roundToDecimal } from '../utils/decimals'
import { createSelector } from '../utils/selector-utils'

/** @type {CaseSelector<number | null>} */
export const selectPatientWeightInKg = caseData => caseData.weight || null
/** @type {CaseSelector<number | null>} */
export const selectPatientHeightInCm = caseData => caseData.height || null
/** @type {CaseSelector<number | null>} */
export const selectBmi = createSelector(
  selectPatientHeightInCm,
  selectPatientWeightInKg,
  /**
   * @param {number} [height]
   * @param {number} [weight]
   * @returns {number | null}
   */
  (height, weight) => {
    if (!height || !weight) {
      return null
    }
    const heightInMeters = height / 100
    const result = roundToDecimal(weight / Math.pow(heightInMeters, 2), 1)
    return Number(result) > 250 ? null : result
  }
)
